var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", md8: "", "offset-md2": "" } }, [
            _c(
              "div",
              { staticClass: "assign-more-btn" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "my-queue",
                    attrs: { color: "grey", dark: "", large: "" },
                    on: {
                      click: function($event) {
                        return _vm.$router.replace("/freeSamplesNew")
                      }
                    }
                  },
                  [_vm._v("Assign More")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md8: "", "offset-md2": "" } },
            [
              _c("v-flex", { attrs: { md4: "", xs12: "", left: "" } }, [
                _c("h1", { staticClass: "mb-3 text-xs-center greyy" }, [
                  _vm._v("Assigned Orders")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "circle" }, [
                  _vm.freeSamplesLoading
                    ? _c(
                        "div",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "pinkk" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.Assigned) +
                            "\n          "
                        )
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { md4: "", xs12: "", left: "" } }, [
                _c("h1", { staticClass: "mb-3 text-xs-center greyy" }, [
                  _vm._v("Closed Orders")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "circle" }, [
                  _vm.freeSamplesLoading
                    ? _c(
                        "div",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "pinkk" }, [
                        _vm._v(
                          "\n            " + _vm._s(_vm.Closed) + "\n          "
                        )
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { md4: "", xs12: "", left: "" } }, [
                _c("h1", { staticClass: "mb-3 text-xs-center greyy" }, [
                  _vm._v("Total Closed Orders")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "circle" }, [
                  _vm.freeSamplesLoading
                    ? _c(
                        "div",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.TotalClosed) +
                            "\n          "
                        )
                      ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md8: "", "offset-md2": "" } },
            [
              _vm.order && _vm.order._id
                ? _c(
                    "v-flex",
                    {
                      staticClass: "table-responsive",
                      attrs: { xs12: "", md12: "" }
                    },
                    [
                      _c(
                        "table",
                        {
                          staticClass: "text-xs-center greyy",
                          attrs: { width: "100%" }
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { width: "20%" }
                                },
                                [_vm._v("Order Code")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { width: "20%" }
                                },
                                [_vm._v("Name")]
                              ),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "20%" } }, [
                                _vm._v("No. Samples")
                              ]),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { width: "20%" }
                                },
                                [_vm._v("Date")]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(_vm._s(_vm.order.orderCode))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  _vm._s(_vm.order.customerID.firstName) +
                                    " " +
                                    _vm._s(_vm.order.customerID.lastName)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.order.freeSamples.length))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  _vm._s(
                                    new Date(_vm.order.date).getDate() +
                                      "/" +
                                      (new Date(_vm.order.date).getMonth() +
                                        1) +
                                      "/" +
                                      new Date(_vm.order.date).getFullYear()
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-left" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "my-queue",
                                      attrs: {
                                        color: "grey",
                                        dark: "",
                                        large: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$modal.show("actionModal")
                                        }
                                      }
                                    },
                                    [_vm._v("Action")]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                : _c(
                    "v-flex",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        xs12: "",
                        md12: "",
                        "text-xs-center": "",
                        "mt-5": "",
                        left: ""
                      }
                    },
                    [
                      _vm.freeSamplesLoading
                        ? _c("div", { staticClass: "greyy no-records" }, [
                            _vm.freeSamplesLoading
                              ? _c(
                                  "div",
                                  {
                                    attrs: {
                                      "justify-center": "",
                                      "align-center": ""
                                    }
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        indeterminate: "",
                                        color: "primary"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _c("div", { staticClass: "greyy no-records" }, [
                            _vm._v("Zero Assigned Orders."),
                            _c("br"),
                            _vm._v("Go get some!")
                          ])
                    ]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm.order && _vm.order._id
            ? _c(
                "v-flex",
                { attrs: { xs12: "", md8: "", "offset-md2": "" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "100%" } },
                    [
                      _vm.tabView === ""
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-xs-right",
                              attrs: { color: "grey", dark: "" },
                              on: {
                                click: function($event) {
                                  _vm.tabView = "list"
                                }
                              }
                            },
                            [_vm._v("List view")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "text-xs-right",
                              attrs: { color: "grey", dark: "" },
                              on: {
                                click: function($event) {
                                  _vm.tabView = ""
                                }
                              }
                            },
                            [_vm._v("Normal view")]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        "background-color": "transparent",
                        color: "basil",
                        grow: ""
                      },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    _vm._l(_vm.itemTypes, function(item, index) {
                      return _c("v-tab", { key: index }, [
                        _vm._v("\n          " + _vm._s(item) + "\n        ")
                      ])
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabView === "list"
                    ? _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        _vm._l(_vm.itemTypes, function(item, index) {
                          return _c(
                            "v-tab-item",
                            { key: index },
                            [
                              _c(
                                "v-card",
                                {
                                  staticStyle: { float: "left", width: "100%" },
                                  attrs: { color: "basil", flat: "" }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    _vm._l(_vm.freeSamples, function(
                                      sample,
                                      label,
                                      sIndex
                                    ) {
                                      return _c("div", { key: sIndex }, [
                                        label === item
                                          ? _c("div", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getFabricList(label)
                                                  )
                                                }
                                              })
                                            ])
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        _vm._l(_vm.itemTypes, function(item, index) {
                          return _c(
                            "v-tab-item",
                            { key: index },
                            [
                              _c(
                                "v-card",
                                { attrs: { color: "basil", flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    _vm._l(_vm.freeSamples, function(
                                      sample,
                                      label,
                                      sIndex
                                    ) {
                                      return _c("div", { key: sIndex }, [
                                        label === item
                                          ? _c("div", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getFabric(label)
                                                  )
                                                }
                                              })
                                            ])
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "modal",
            { staticClass: "printLableModal", attrs: { name: "actionModal" } },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "", row: "", "text-xs-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "" } },
                    [
                      _c(
                        "v-tabs",
                        {
                          attrs: {
                            "background-color": "transparent",
                            color: "basil",
                            grow: ""
                          },
                          model: {
                            value: _vm.tabModal,
                            callback: function($$v) {
                              _vm.tabModal = $$v
                            },
                            expression: "tabModal"
                          }
                        },
                        [
                          _c("v-tab", [_vm._v(" Print Label ")]),
                          _vm._v(" "),
                          _c("v-tab", [_vm._v(" Tracking Reference ")]),
                          _vm._v(" "),
                          _c("v-tab", [_vm._v(" Mark Complete ")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tabModal,
                            callback: function($$v) {
                              _vm.tabModal = $$v
                            },
                            expression: "tabModal"
                          }
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _vm.order && _vm.order._id
                                ? _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        sm12: "",
                                        "margin-auto": "",
                                        "text-sm-center": ""
                                      }
                                    },
                                    [
                                      _c("h1", [_vm._v("Address label")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "235px",
                                            height: "110px",
                                            border: "1px solid",
                                            "text-align": "left",
                                            "font-size": "18px",
                                            padding: "5px",
                                            margin: "0 auto"
                                          },
                                          attrs: { id: "printMe" }
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.order.customerID.firstName
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.order.customerID.lastName
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.order.customerID.phone)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.order.customerID.address &&
                                                  _vm.order.customerID.address
                                                    .address
                                                  ? _vm.order.customerID.address
                                                      .address
                                                  : ""
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.order.customerID.address &&
                                                  _vm.order.customerID.address
                                                    .city
                                                  ? _vm.order.customerID.address
                                                      .city
                                                  : ""
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.order.customerID
                                                    .address &&
                                                    _vm.order.customerID.address
                                                      .state
                                                    ? _vm.order.customerID
                                                        .address.state
                                                    : ""
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.order.customerID
                                                    .address &&
                                                    _vm.order.customerID.address
                                                      .postcode
                                                    ? _vm.order.customerID
                                                        .address.postcode
                                                    : ""
                                                )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-4" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "large-buttons confirm_msg_button cursor-pointer",
                                              attrs: {
                                                color: "grey",
                                                dark: "",
                                                large: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.print()
                                                }
                                              }
                                            },
                                            [_vm._v("Print")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            [
                              _vm.order && _vm.order._id
                                ? _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        sm12: "",
                                        "margin-auto": "",
                                        "text-sm-center": ""
                                      }
                                    },
                                    [
                                      _c("h1", [_vm._v("Tracking Reference")]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: { label: "Tracking Reference" },
                                        model: {
                                          value: _vm.order.trackingReference,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.order,
                                              "trackingReference",
                                              $$v
                                            )
                                          },
                                          expression: "order.trackingReference"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-4" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "large-buttons confirm_msg_button cursor-pointer",
                                              attrs: {
                                                color: "grey",
                                                dark: "",
                                                large: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.saveTrackingReference()
                                                }
                                              }
                                            },
                                            [_vm._v("Save")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            [
                              _vm.order && _vm.order._id
                                ? _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        sm12: "",
                                        "margin-auto": "",
                                        "text-sm-center": ""
                                      }
                                    },
                                    [
                                      _c("h1", [
                                        _vm._v(
                                          " Are you sure to mark the order completed? "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-4" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "large-buttons confirm_msg_button cursor-pointer",
                                              attrs: {
                                                color: "grey",
                                                dark: "",
                                                large: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.Completed()
                                                }
                                              }
                                            },
                                            [_vm._v("Mark Completed")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-337f3b33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337f3b33","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/freeSamples/MyQueue.vue
// module id = null
// module chunks = 